// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__23V5U","signatureButtonsRight":"ModalSign_signatureButtonsRight__3P-bg"};